import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingAutomationRule.Save.IRequest;
type Response = Api.Core.ProductPricingAutomationRule.Save.IResponse;
type Headers = Api.Core.ProductPricingAutomationRule.Save.IHeaders;
const url = '/api/ProductManagement/ProductPricingAutomationRule';
export default async function productPricingAutomationRuleSaveApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
